import React from 'react';
import { makeStyles } from '@material-ui/core';

import { setClassNameInDefns } from '../../common/definitionHelper';
import { ANY_OCCUPATIONS, FILTER_OPTION_JOB_TYPE_ALL_JOB_TYPES, SORT_OPTION_DATE, SORT_OPTION_DISTANCE, SORT_OPTION_RELEVANCE } from '../../common/constants';
import { getSalaryRateFilterText } from '../../common/textHelper';
import { ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC, ELASTICSEARCH_SORT_OPTION_DISTANCE_ASC, ELASTICSEARCH_SORT_OPTION_MOST_RELEVANT } from '../../common/elasticSearchHelper';

import AfitdTypography from '../../common/elemental/AfitdTypography';

import _join from 'lodash/join';
import _includes from 'lodash/includes';
import _isNil from 'lodash/isNil';
import _isEqual from 'lodash/isEqual';

const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            width: '100%',
        },
        heading: {
            color: '#111E14',
            fontWeight: 'bold',
        },
        text: {
            color: '#9B9E9C',
        },
    }));
};

const getDefns = params => {
    const { classes, props } = params;

    const defns = {
        root: {
            onClick: props.onClick,
        },
        heading: {
            variant: 'subtitle1',
        },
        text: {
            variant: 'subtitle2',
        },
    };

    // inject classes
    setClassNameInDefns(defns, classes);

    return defns;
};

const SearchSaveItem = props => {
    const classes = useStyles(/*{param1, param2}*/)();

    const defns = getDefns({
        classes,
        props,
    });

    const { jobType = [], datePost, salaryRate, occupation, location, sortTag } = props;

    let occupationText = occupation;
    const filterStringList = [];

    // occupation
    if (!occupation) {
        occupationText = ANY_OCCUPATIONS;
    }

    // location
    location && filterStringList.push(location?.label || '');

    // job types
    if (jobType.length > 0) {
        const isAllJobTypes = _includes(jobType, FILTER_OPTION_JOB_TYPE_ALL_JOB_TYPES);
        const jobTypeFilters = isAllJobTypes ? FILTER_OPTION_JOB_TYPE_ALL_JOB_TYPES : _join(jobType, ', ');
        filterStringList.push(jobTypeFilters);
    }

    // date posted
    datePost && filterStringList.push(datePost);

    // salary/rate
    if (salaryRate) {
        const rateMin = salaryRate.rateMin;
        const payFrequency = salaryRate.payFrequency;
        const currencySymbol = salaryRate.currencySymbol;

        if (!_isNil(rateMin) && !_isNil(payFrequency)) {
            filterStringList.push(getSalaryRateFilterText(rateMin, currencySymbol, payFrequency));
        }
    }

    // sort order
    if (_isEqual(sortTag, ELASTICSEARCH_SORT_OPTION_MOST_RELEVANT)) {
        filterStringList.push(`Sort by ${SORT_OPTION_RELEVANCE}`);
    } else if (_isEqual(sortTag, ELASTICSEARCH_SORT_OPTION_UPDATE_DATE_DESC)) {
        filterStringList.push(`Sort by ${SORT_OPTION_DATE}`);
    } else if (_isEqual(sortTag, ELASTICSEARCH_SORT_OPTION_DISTANCE_ASC)) {
        filterStringList.push(`Sort by ${SORT_OPTION_DISTANCE}`);
    }

    return (
        <div {...defns.root}>
            <div>
                <AfitdTypography {...defns.heading}>{occupationText}</AfitdTypography>
            </div>
            <div>
                <AfitdTypography {...defns.text}>{filterStringList.join(', ')}</AfitdTypography>
            </div>
        </div>
    );
};

export default SearchSaveItem;
